import axios from 'axios';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { useAuth } from '../../Context/AuthContext';
import './Login.css'
const Login = () => {
    const navigate = useNavigate();
    const { isAuthenticated, setIsAuthenticated, setUser } = useAuth();;

    useEffect(() => {
        isAuthenticated && navigate('/dashboard/admin');
    }, [isAuthenticated, navigate]);
    const handleLogin = e => {
        e.preventDefault();
        axios.post(`${process.env.REACT_APP_API_LINK}admin/login`, {
            email: e.target.email.value,
            password: e.target.password.value,
        })
            .then(res => {
                if (res.data.authenticated) {
                    setUser(res.data.user);
                    setIsAuthenticated(res.data.authenticated);
                    if (e.target.remember.checked) {
                        window.localStorage.setItem('user', JSON.stringify(res.data.user));
                    };
                }
                else {
                    swal({
                        title: "Error!",
                        text: "Email or Pass did't Match",
                        icon: "error",
                        buttons: true,
                        dangerMode: true,
                    })
                }
            });
    };
    return (
        <>
            <body id="particless-js"></body>
            <div>
                <div className="contaainerr">
                    <span className="errorrs"></span>
                    <form onSubmit={handleLogin} name="form1" className="boxxs">
                        <h4 className='mb-5'>Admin<span>Dashboard</span></h4>
                        <h5>Sign in to your account.</h5>
                        <input type="text" name="email" placeholder="Email" autoComplete="off" />
                        <i className="typcnnn typcnnn-eye"></i>
                        <input type="password" name="password" placeholder="Passsword" id="pwd" autoComplete="off" />
                        <div className='d-flex'>
                            <div className='mx-2 pt-1 pl-5'>
                                <input name='remember' className='mt-3 ms-4' type="checkbox" />
                            </div>
                            <p className="rmbs mt-3">Remember me</p>
                        </div>
                        <input type="submit" value="Sign in" className="signinBtn" />
                    </form>
                </div>
            </div>
        </>
    );
};

export default Login;